import {
  addItemToCart,
  addMultiItemsToCart,
  createCart,
  getCart,
} from "@/services/cart";
import { getCookies, setCookie } from "cookies-next";
import toast from "react-hot-toast";

const addICartItem = async (
  handshake,
  mage,
  quote,
  product,
  qty,
  dispatch,
  configurations,
  context,
  relatedProducts
) => {
  const sku = Array.isArray(product?.sku) ? product?.sku?.at(0) : product?.sku;
  const bundleItems =
    product?.type_id === "bundle" && product?.bundle_product_options?.length > 0
      ? product?.bundle_product_options?.map((item) => ({
          option_id: item?.option_id,
          option_qty: qty,
          option_selections: item?.product_links?.map((opt) => opt?.id),
        }))
      : null;
  const { data, error } = await addItemToCart(
    handshake,
    mage,
    quote,
    sku,
    qty,
    configurations,
    bundleItems
  );

  if (error || !data?.quoteId || !data?.data)
    return toast.error(
      error?.error?.message ||
        "The product that was requested doesn't exist. Verify the product and try again."
    );

  if (data?.quoteId && quote != data?.quoteId) {
    dispatch({ type: "clear" });
    setCookie("quote", data?.quoteId);
  }

  setTimeout(() => {
    context?.dispatch({
      type: "cartInfo",
      payload: product,
      payloadRelatedProducts: relatedProducts,
    });
  }, 0);

  dispatch({ type: "add_item", payload: { ...product, ...data?.data } });
  data?.message && toast.success(data?.message);
};

export const handleAddItemToCart = async (
  product,
  qty,
  setLoading,
  dispatchCart,
  configurations,
  context,
  relatedProducts
) => {
  setLoading(true);
  const { handshake, quote, mage } = getCookies();
  // 1 check if user has a cart. If not generate one and save it to cookies
  if (!quote) {
    const { data: newCart } = await createCart(handshake, mage);
    // 2 .5 Set the cookie with the id of the new cart in users browser and add item to cart
    if (newCart?.cart_id) {
      setCookie("quote", newCart?.cart_id);
      await addICartItem(
        handshake,
        mage,
        newCart?.cart_id,
        product,
        qty,
        dispatchCart,
        configurations,
        context,
        relatedProducts
      );
      return setLoading(false);
    }
    return setLoading(false);
  }
  //If user already has a cart just add the item to their existing cart
  await addICartItem(
    handshake,
    mage,
    quote,
    product,
    qty,
    dispatchCart,
    configurations,
    context,
    relatedProducts
  );
  return setLoading(false);
};

// eslint-disable-next-line no-unused-vars
const addCartItems = async (
  handshake,
  mage,
  quote,
  products,
  dispatch,
  configurations,
  context,
  relatedProducts,
  selectedProducts
) => {
  // const skus = products?.map(item => typeof item?.sku == "string" ? item?.sku : item?.sku?.at(0))
  const { data, error } = await addMultiItemsToCart(
    handshake,
    mage,
    quote,
    products?.map((item) => {
      const selcetedConfiguration = configurations?.find(
        (itemF) => itemF?.sku == item?.sku
      );
      return selcetedConfiguration
        ? {
            ...item,
            product_type: selcetedConfiguration?.product_type,
            product_option: selcetedConfiguration?.product_option,
          }
        : item;
    })
  );

  console.log("===========================> products", selectedProducts);

  if (error)
    return toast.error(
      error?.error?.message ||
        "The product that was requested doesn't exist. Verify the product and try again."
    );
  console.log("quote =====>", quote, data?.quoteId);

  if (quote !== data?.quoteId) {
    dispatch({ type: "clear" });
    setCookie("quote", data?.quoteId);
  }
  // console.log("data?.data -------- ", data?.data);
  dispatch({
    type: "add_bundle",
    payload: data?.data?.filter((i) => typeof i != "string") || [],
  });
  data?.message && toast.success(data?.message);
  const res = await getCart(handshake, mage, quote);
  console.log("res?.data?.data --------- ", res?.data?.data);
  console.log("res?.data --------- ", res?.data);
  dispatch({ type: "get_cart", payload: res?.data?.data });

  (res?.data?.data?.length || res?.data?.data?.items?.length) &&
    setTimeout(() => {
      context?.dispatch({
        type: "cartInfo",
        payloadRelatedProducts: relatedProducts,
      });
    }, 0);

  // dispatch({ type: "add_item", payload: res?.data?.data });

  if (
    data?.data?.length > 0 &&
    data?.data?.some((el) => typeof el == "string")
  ) {
    return data?.data?.map((el) => typeof el == "string" && toast.error(el));
  }

  console.log({ products, data, error });
};

export const handleAddItemsToCart = async (
  products,
  setLoading,
  dispatchCart,
  configurations,
  context,
  relatedProducts,
  selectedProducts
) => {
  setLoading(true);

  const { handshake, quote, mage } = getCookies();
  // 1 check if user has a cart. If not generate one and save it to cookies
  if (!quote) {
    const { data: newCart } = await createCart(handshake, mage);
    // 2 .5 Set the cookie with the id of the new cart in users browser and add item to cart
    if (newCart?.cart_id) {
      setCookie("quote", newCart?.cart_id);
      await addCartItems(
        handshake,
        mage,
        newCart?.cart_id,
        products,
        dispatchCart,
        configurations,
        context,
        relatedProducts,
        selectedProducts
      );
      return setLoading(false);
    }
    return setLoading(false);
  }
  //If user already has a cart just add the item to their existing cart
  await addCartItems(
    handshake,
    mage,
    quote,
    products,
    dispatchCart,
    configurations,
    context,
    relatedProducts,
    selectedProducts
  );
  return setLoading(false);
};
